import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/category", label: "影视分类" },
  { to: "/search", label: "搜索" },
  { to: "/about", label: "关于我们" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
  };

  const solid = scrolled || location.pathname !== "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-gradient-to-b from-foreground-950/60 to-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-film-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-black tracking-wide ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              国产精品久久
            </span>
            <span
              className={`mt-1 text-[10px] tracking-[0.2em] ${
                solid ? "text-foreground-600" : "text-background-200"
              }`}
            >
              CHINESE CINEMA
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-md px-3.5 py-2 text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive
                    ? solid
                      ? "bg-primary-50 text-primary-700 font-medium"
                      : "bg-background-50/20 text-background-50 font-medium"
                    : solid
                      ? "text-foreground-700 hover:text-primary-600"
                      : "text-background-100 hover:text-background-50"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form
          onSubmit={handleSearch}
          className={`hidden lg:flex items-center gap-2 rounded-md border px-3 py-1.5 w-72 ${
            solid
              ? "border-background-300 bg-background-100"
              : "border-background-50/30 bg-foreground-950/30"
          }`}
        >
          <i
            className={`ri-search-line text-sm ${
              solid ? "text-foreground-500" : "text-background-200"
            }`}
          />
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索影视名称、导演、演员"
            className={`w-full bg-transparent text-sm outline-none placeholder:text-foreground-500 ${
              solid ? "text-foreground-900" : "text-background-50 placeholder:text-background-300"
            }`}
          />
          <button
            type="submit"
            className="rounded bg-accent-500 px-2 py-0.5 text-xs text-background-50 whitespace-nowrap cursor-pointer hover:bg-accent-600"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="打开菜单"
          className={`md:hidden flex h-9 w-9 items-center justify-center rounded-md cursor-pointer ${
            solid ? "text-foreground-900 bg-background-100" : "text-background-50 bg-foreground-950/30"
          }`}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
        </button>
      </div>

      {menuOpen ? (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 animate-fade-in">
          <form
            onSubmit={handleSearch}
            className="mb-3 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2"
          >
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视名称"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
            />
          </form>
          <div className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-sm ${
                    isActive ? "bg-primary-50 text-primary-700 font-medium" : "text-foreground-800"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </NavLink>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}